import p5Wrapper from "./P5Wrapper";
export default p5Wrapper();
